import { useFeatureConfig } from '../contexts/FeatureContext';

export function useFeatures() {
  const { config } = useFeatureConfig();

  if (!config) {
    // Return loading state with safe defaults
    // During loading, assume features are enabled to avoid unnecessary redirects
    return {
      isAdsEnabled: true,
      isWishesEnabled: true,
      isProductsEnabled: true,
      isCartEnabled: true,
      isCheckoutEnabled: true,
      isOrdersEnabled: true,
      showAdsLink: true,
      showWishesLink: true,
      showProductsLink: true,
      isMaintenanceMode: false,
      maintenanceMessage: undefined,
      allowAdminAccess: true,
      loading: true,
      config: null,
    };
  }

  return {
    isAdsEnabled: config.platforms.advertising && config.ads.listing,
    isWishesEnabled: config.platforms.advertising && config.wishes.listing,
    isProductsEnabled: config.platforms.ecommerce && config.products.listing,
    isCartEnabled: config.platforms.ecommerce && config.shopping.cart,
    isCheckoutEnabled: config.platforms.ecommerce && config.shopping.checkout,
    isOrdersEnabled: config.platforms.ecommerce && config.shopping.orders,
    showAdsLink: config.navigation.showAdsLink,
    showWishesLink: config.navigation.showWishesLink,
    showProductsLink: config.navigation.showProductsLink,
    isMaintenanceMode: config.maintenance?.enabled ?? false,
    maintenanceMessage: config.maintenance?.message,
    allowAdminAccess: config.maintenance?.allowAdminAccess ?? true,
    loading: false,
    config,
  };
}
